// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-search-date-picker-___search-date-picker__search-date-field___O1vX3 {
  border-left: 1px solid var(--default-border);
  padding: 0 0.5em;
  font-weight: normal;
  color: var(--gray-light);
  margin-bottom: 0;

  input {
    border: none;
    margin-left: 0.1em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/search-date-picker/search-date-picker.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;;EAEhB;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".search-date-field {\n  border-left: 1px solid var(--default-border);\n  padding: 0 0.5em;\n  font-weight: normal;\n  color: var(--gray-light);\n  margin-bottom: 0;\n\n  input {\n    border: none;\n    margin-left: 0.1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-date-field": `src-components-search-date-picker-___search-date-picker__search-date-field___O1vX3`,
	"searchDateField": `src-components-search-date-picker-___search-date-picker__search-date-field___O1vX3`
};
export default ___CSS_LOADER_EXPORT___;
